import { createContext, RefObject } from 'react';

export type MenuListContextType = {
    triggerRef: RefObject<HTMLElement> | null;
    levels: RefObject<RefObject<HTMLDivElement>[]> | null;
    onItemClick: () => void;
};

export const MenuListContext = createContext<MenuListContextType>({
    triggerRef: null,
    levels: null,
    onItemClick: () => {},
});
